export const VUETIFY_DEFAULTS_KEY = Symbol.for("vuetify:defaults");

import type { InjectionKey, Ref } from "vue";

// use Symbol here to make vuetify to catch this key. Vuetify lib is waiting only for Symbol type key
export const PIP_ATTACH_KEY: InjectionKey<Ref<HTMLElement | null>> = Symbol("pipAttach");

export const PIP_ROOT_CLASS = "pip-root";
